module.exports = __webpack_public_path__ + "static/media/criteria-8.2-rsp.8ce0fe95.jpg";